import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../api/api';
import { Card, Button, Icon } from '../../components/ui';

export default function Annexes() {
  const [arAging, setArAging] = useState(null);
  const [apAging, setApAging] = useState(null);
  const [loadingAr, setLoadingAr] = useState(false);
  const [loadingAp, setLoadingAp] = useState(false);

  const loadArAging = async () => {
    try {
      setLoadingAr(true);
      const res = await api.get('/accounting/annexes/aged-ar');
      setArAging(res.data);
    } catch (e) {
      toast.error(e.response?.data?.error || e.message);
    } finally {
      setLoadingAr(false);
    }
  };

  const loadApAging = async () => {
    try {
      setLoadingAp(true);
      const res = await api.get('/accounting/annexes/aged-ap');
      setApAging(res.data);
    } catch (e) {
      toast.error(e.response?.data?.error || e.message);
    } finally {
      setLoadingAp(false);
    }
  };

  const formatCurrency = (v) => new Intl.NumberFormat('fr-TN', { style: 'currency', currency: 'TND' }).format(v || 0);

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">
          <Icon name="IconClipboardList" className="text-indigo-600 mr-3" />
          Annexes comptables
        </h1>
        <p className="text-sm text-gray-600 mt-1">États annexes : échéanciers clients/fournisseurs.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-bold text-gray-800">Échéancier Clients</h2>
            <Button onClick={loadArAging} disabled={loadingAr} size="sm">
              {loadingAr ? 'Chargement...' : 'Actualiser'}
            </Button>
          </div>

          {arAging?.agingSummary && (
            <div className="space-y-3 mb-4">
              {Object.entries(arAging.agingSummary).map(([bucket, data]) => (
                <div key={bucket} className="flex justify-between py-2 px-3 bg-gray-50 rounded">
                  <span className="font-semibold">{bucket}</span>
                  <div>
                    <span className="mr-4">{data.count} clients</span>
                    <span className="font-bold">{formatCurrency(data.total)}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {arAging?.items && (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2 text-left text-xs text-gray-500 uppercase">Solde</th>
                    <th className="px-3 py-2 text-center text-xs text-gray-500 uppercase">Échéance</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {arAging.items.slice(0, 20).map((item, i) => (
                    <tr key={i} className="hover:bg-gray-50">
                      <td className="px-3 py-2 text-sm font-semibold">{formatCurrency(item.solde)}</td>
                      <td className="px-3 py-2 text-sm text-center">
                        <span className={`px-2 py-1 rounded text-xs ${
                          item.aging === '+90 jours' ? 'bg-red-100 text-red-700' :
                          item.aging === '61-90 jours' ? 'bg-orange-100 text-orange-700' :
                          'bg-green-100 text-green-700'
                        }`}>
                          {item.aging}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card>

        <Card>
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-bold text-gray-800">Échéancier Fournisseurs</h2>
            <Button onClick={loadApAging} disabled={loadingAp} size="sm">
              {loadingAp ? 'Chargement...' : 'Actualiser'}
            </Button>
          </div>

          {apAging?.agingSummary && (
            <div className="space-y-3 mb-4">
              {Object.entries(apAging.agingSummary).map(([bucket, data]) => (
                <div key={bucket} className="flex justify-between py-2 px-3 bg-gray-50 rounded">
                  <span className="font-semibold">{bucket}</span>
                  <div>
                    <span className="mr-4">{data.count} fournisseurs</span>
                    <span className="font-bold">{formatCurrency(data.total)}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {apAging?.items && (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2 text-left text-xs text-gray-500 uppercase">Solde</th>
                    <th className="px-3 py-2 text-center text-xs text-gray-500 uppercase">Échéance</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {apAging.items.slice(0, 20).map((item, i) => (
                    <tr key={i} className="hover:bg-gray-50">
                      <td className="px-3 py-2 text-sm font-semibold">{formatCurrency(item.solde)}</td>
                      <td className="px-3 py-2 text-sm text-center">
                        <span className={`px-2 py-1 rounded text-xs ${
                          item.aging === '+90 jours' ? 'bg-red-100 text-red-700' :
                          item.aging === '61-90 jours' ? 'bg-orange-100 text-orange-700' :
                          'bg-green-100 text-green-700'
                        }`}>
                          {item.aging}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
